module.exports = __webpack_public_path__ + "static/media/B61915-RECEIV_1.1672c45d.PDF";